const initialState = {
  tokenAccess: undefined,
  tokenRefresh: undefined,
  isLoading: false,
  userCode: '',
  userDefaultHotel: '',
  userDefaultLang: 'es',
  mainDirtyIndicator: false,
  allHotelsList: []
};

const session = (state = initialState, action = { type: '' }) => {
  switch (action.type) {
    case 'TOGGLE_LOADING_INDICATOR': {
      const { isLoading } = action;

      return {
        ...state,
        isLoading: isLoading
      }
    }
    case 'CREATE_TOKEN': {
      return {
        ...state,
        tokenAccess: action.token.tokenAccess,
        tokenRefresh: action.token.tokenRefresh
      };
    }
    case 'REFRESH_TOKEN': {
      return {
        ...state,
        tokenAccess: action.newToken.tokenAccess,
        tokenRefresh: action.newToken.tokenRefresh
      };
    }
    case 'SET_CRS_DATA': {
      return {
        ...state,
        userCode: action.crsData.userName,
        userDefaultHotel: action.crsData.hotelId,
        userDefaultLang: action.crsData.language
      };
    }
    case 'GET_ALL_HOTELS_LIST': {
      const { response } = action;

      let finalHotelsList = [];
      if (response.length !== 0) {
        finalHotelsList = action.response.map(hotelBean => (
          { label: hotelBean.name, value: hotelBean.code }
        ));
      }

      return {
        ...state,
        allHotelsList: finalHotelsList,
        sessionRequestLoading: false
      };
    }
    default:
      return state;
  }
}

export default session;
